import { render, staticRenderFns } from "./TableTypesTab.vue?vue&type=template&id=703152da&scoped=true&"
import script from "./TableTypesTab.vue?vue&type=script&lang=js&"
export * from "./TableTypesTab.vue?vue&type=script&lang=js&"
import style0 from "./TableTypesTab.vue?vue&type=style&index=0&id=703152da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703152da",
  null
  
)

export default component.exports